import { MouseEvent, useCallback } from 'react';
import { useExperimentFlag } from '../../../../utils/useExperimentFlag';
import { PostButton as PostButtonBase } from '../../PostButton/PostButton';
import { PostUI } from '../../types';
import { PostDetailsCardProps, usePostDetailsCardContext } from '../PostDetailsCard';
import { makeMediaParams } from '../utils';

export interface PostButtonProps {
    post: PostUI;
    isProductExpanded: boolean;
    onClickOutClick: PostDetailsCardProps['onClickOutClick'];
    onProductButtonClick: PostDetailsCardProps['onProductButtonClick'];
}

const ANIMATE_TIME = 250;

export const PostButton = ({
    post,
    isProductExpanded,
    onClickOutClick,
    onProductButtonClick,
}: PostButtonProps) => {
    const { activeIndex } = usePostDetailsCardContext();

    const products = post.products;
    const clickOut = (post.clickouts ?? []).find((c) => c.target === 'button' && c.url);

    const disableServiceBooking = Number(useExperimentFlag('disable_service_booking')) === 1;
    const hasBookingButton = !disableServiceBooking && post.business?.isDikidiApproved;

    const handleClickOutClick = useCallback(
        (event: MouseEvent<HTMLElement>) => {
            onClickOutClick?.(makeMediaParams(post, activeIndex));
            event.stopPropagation();
        },
        [activeIndex, post, onClickOutClick],
    );

    return (
        <PostButtonBase
            clickOut={clickOut}
            onClickOutClick={handleClickOutClick}
            products={products}
            businessType={post.business?.type}
            isProductExpanded={isProductExpanded}
            transitionTiming={ANIMATE_TIME}
            onProductButtonClick={onProductButtonClick}
            hasBookingButton={hasBookingButton}
        />
    );
};
